import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { signOutUser } from "../firebase/auth";
import Navigation from "../components/Navigation";

const AccountScreenLoggedIn = () => {
  const navigate = useNavigate();
  const { 
    user, 
    marketCurrency, 
    setMarketCurrency, 
    portfolioCurrency, 
    setPortfolioCurrency, 
    isTtwror, 
    setIsTtwror,
    saveUserPreferences,
    setMockUser,
  } = useAuth();
  const [showCurrencyModal, setShowCurrencyModal] = useState(false);
  const [currencyTypeToChange, setCurrencyTypeToChange] = useState(null);
  const [showToast, setShowToast] = useState(false);
  const [toastText, setToastText] = useState("");
  const [showPlaceholder, setShowPlaceholder] = useState(false);
  const [placeholderText, setPlaceholderText] = useState("");

  const currencies = [
    { code: "USD", name: "US Dollar", symbol: "$" },
    { code: "EUR", name: "Euro", symbol: "€" },
    { code: "PLN", name: "Polish Złoty", symbol: "zł" },
    { code: "GBP", name: "British Pound", symbol: "£" },
    { code: "JPY", name: "Japanese Yen", symbol: "¥" },
    { code: "DKK", name: "Danish Krone", symbol: "kr" },
  ];

  const handleCurrencyChange = async (newCurrency) => {
    try {
      let preferences = {};
      let successMessage = "";
      
      if (currencyTypeToChange === "market") {
        preferences.marketCurrency = newCurrency.code;
        setMarketCurrency(newCurrency.code);
        successMessage = `Market currency changed to ${newCurrency.name}`;
      }
      if (currencyTypeToChange === "portfolio") {
        preferences.portfolioCurrency = newCurrency.code;
        setPortfolioCurrency(newCurrency.code);
        successMessage = `Portfolio currency changed to ${newCurrency.name}`;
      }
      
      // Save to database
      const result = await saveUserPreferences(preferences);
      
      if (result.success) {
        setToastText(successMessage);
        setShowToast(true);
        setTimeout(() => setShowToast(false), 1500);
      } else {
        alert("Failed to save currency preference");
      }
    } catch (error) {
      console.error("Error changing currency:", error);
      alert("Failed to save currency preference");
    } finally {
      setShowCurrencyModal(false);
      setCurrencyTypeToChange(null);
    }
  };

  const openPlaceholder = (text) => {
    setPlaceholderText(text);
    setShowPlaceholder(true);
  };

  const handleLogout = async () => {
    try {
      await signOutUser();
      setMockUser(null);
      navigate("/");
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  return (
    <div className="screen">
      <Navigation />
      <div className="screen-header" style={{ marginTop: 56 }}>
        <h1 className="screen-title">Account Settings</h1>
      </div>
      <div
        className="card"
        style={{ maxWidth: 520, margin: "32px auto", padding: 32 }}
      >
        {/* Profile Section */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 24,
            marginBottom: 32,
          }}
        >
          <div
            style={{
              width: 64,
              height: 64,
              borderRadius: "50%",
              background: "#222",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 36,
              color: "#3B82F6",
            }}
          >
            <span role="img" aria-label="avatar">
              👤
            </span>
          </div>
          <div>
            <div style={{ fontWeight: 700, fontSize: "1.3rem", color: "#fff" }}>
              {user?.displayName || user?.email?.split("@")[0] || "User"}
            </div>
            <div style={{ color: "#94A3B8", fontSize: "1.05rem" }}>
              {user?.email || "No email"}
            </div>
            {user?.emailVerified && (
              <div
                style={{
                  color: "#22C55E",
                  fontWeight: 600,
                  fontSize: "0.98rem",
                  marginTop: 2,
                }}
              >
                ✓ Email Verified
              </div>
            )}
          </div>
        </div>
        {/* Preferences Section */}
        <div style={{ marginBottom: 28 }}>
          <div style={{ fontWeight: 600, color: "#fff", marginBottom: 10 }}>
            Preferences
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                cursor: "pointer",
              }}
              onClick={() => {
                setCurrencyTypeToChange("market");
                setShowCurrencyModal(true);
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <span style={{ color: "#3B82F6", fontSize: 20 }}>💵</span>
                <div>
                  <div style={{ fontWeight: 500, color: "#E5E7EB" }}>
                    Market Currency
                  </div>
                  <div style={{ color: "#94A3B8", fontSize: "0.98rem" }}>
                    {currencies.find((c) => c.code === marketCurrency)?.name} (
                    {marketCurrency})
                  </div>
                </div>
              </div>
              <span style={{ color: "#94A3B8", fontSize: 18 }}>›</span>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                cursor: "pointer",
              }}
              onClick={() => {
                setCurrencyTypeToChange("portfolio");
                setShowCurrencyModal(true);
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <span style={{ color: "#3B82F6", fontSize: 20 }}>👛</span>
                <div>
                  <div style={{ fontWeight: 500, color: "#E5E7EB" }}>
                    Portfolio Currency
                  </div>
                  <div style={{ color: "#94A3B8", fontSize: "0.98rem" }}>
                    {currencies.find((c) => c.code === portfolioCurrency)?.name}{" "}
                    ({portfolioCurrency})
                  </div>
                </div>
              </div>
              <span style={{ color: "#94A3B8", fontSize: 18 }}>›</span>
            </div>
            {/* TTWROR Switch */}
            <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: 0,
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <span style={{ color: "#3B82F6", fontSize: 20 }}>🧮</span>
                  <div style={{ fontWeight: 500, color: "#E5E7EB" }}>
                    Portfolio Calculation
                  </div>
                </div>
                {/* Custom Switch - smaller */}
                <label
                  style={{
                    position: "relative",
                    display: "inline-block",
                    width: 32,
                    height: 16,
                    marginLeft: 12,
                  }}
                >
                  <input
                    type="checkbox"
                    checked={isTtwror}
                    onChange={async (e) => {
                      const value = e.target.checked;
                      setIsTtwror(value);
                      // Save to database
                      try {
                        await saveUserPreferences({ isTtwror: value });
                      } catch (error) {
                        console.error("Error saving TTWROR preference:", error);
                      }
                    }}
                    style={{ opacity: 0, width: 0, height: 0 }}
                  />
                  <span
                    style={{
                      position: "absolute",
                      cursor: "pointer",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      background: isTtwror ? "#3B82F6" : "#444",
                      borderRadius: 16,
                      transition: "background 0.2s",
                      boxShadow: isTtwror ? "0 0 4px #3B82F6" : "none",
                    }}
                  ></span>
                  <span
                    style={{
                      position: "absolute",
                      left: isTtwror ? 16 : 2,
                      top: 2,
                      width: 12,
                      height: 12,
                      background: "#fff",
                      borderRadius: "50%",
                      transition: "left 0.2s",
                      boxShadow: "0 1px 4px #0003",
                    }}
                  ></span>
                </label>
              </div>
              <div
                style={{
                  color: "#94A3B8",
                  fontSize: "0.98rem",
                  marginTop: 0,
                  marginLeft: 38,
                  textAlign: "left",
                  lineHeight: 1.2,
                }}
              >
                {isTtwror ? "Time-Weighted (TTWROR)" : "Standard Method"}
              </div>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                cursor: "pointer",
              }}
              onClick={() =>
                openPlaceholder("Notifications settings coming soon")
              }
            >
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <span style={{ color: "#3B82F6", fontSize: 20 }}>🔔</span>
                <div>
                  <div style={{ fontWeight: 500, color: "#E5E7EB" }}>
                    Notifications
                  </div>
                  <div style={{ color: "#94A3B8", fontSize: "0.98rem" }}>
                    Manage your notifications
                  </div>
                </div>
              </div>
              <span style={{ color: "#94A3B8", fontSize: 18 }}>›</span>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                cursor: "pointer",
              }}
              onClick={() => openPlaceholder("Security settings coming soon")}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <span style={{ color: "#3B82F6", fontSize: 20 }}>🛡️</span>
                <div>
                  <div style={{ fontWeight: 500, color: "#E5E7EB" }}>
                    Security
                  </div>
                  <div style={{ color: "#94A3B8", fontSize: "0.98rem" }}>
                    Two-factor authentication, login history
                  </div>
                </div>
              </div>
              <span style={{ color: "#94A3B8", fontSize: 18 }}>›</span>
            </div>
          </div>
        </div>
        {/* Help & Support Section */}
        <div style={{ marginBottom: 28 }}>
          <div style={{ fontWeight: 600, color: "#fff", marginBottom: 10 }}>
            Account
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              cursor: "pointer",
            }}
            onClick={() => openPlaceholder("Help & Support coming soon")}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <span style={{ color: "#3B82F6", fontSize: 20 }}>❓</span>
              <div>
                <div style={{ fontWeight: 500, color: "#E5E7EB" }}>
                  Help & Support
                </div>
                <div style={{ color: "#94A3B8", fontSize: "0.98rem" }}>
                  Get help and contact support
                </div>
              </div>
            </div>
            <span style={{ color: "#94A3B8", fontSize: 18 }}>›</span>
          </div>
          <button
            type="button"
            className="btn btn-error btn-large w-full"
            style={{ marginTop: 20 }}
            onClick={handleLogout}
          >
            Log out
          </button>
        </div>
      </div>
      {/* Currency Modal */}
      {showCurrencyModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.6)",
            zIndex: 1000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              background: "#181C28",
              borderRadius: 18,
              padding: 32,
              minWidth: 320,
              maxHeight: 420,
              overflowY: "auto",
            }}
          >
            <div
              style={{
                fontWeight: 700,
                color: "#fff",
                marginBottom: 18,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <span>Select Currency</span>
              <button
                className="btn btn-small"
                onClick={() => setShowCurrencyModal(false)}
              >
                ✕
              </button>
            </div>
            {currencies.map((c) => {
              let selected = false;
              if (currencyTypeToChange === "market")
                selected = marketCurrency === c.code;
              if (currencyTypeToChange === "portfolio")
                selected = portfolioCurrency === c.code;
              return (
                <button
                  key={c.code}
                  className={`btn btn-small${selected ? " btn-secondary" : ""}`}
                  style={{ width: "100%", marginBottom: 8 }}
                  onClick={() => handleCurrencyChange(c)}
                >
                  {c.symbol} {c.name} ({c.code}) {selected && "✓"}
                </button>
              );
            })}
            <button
              className="btn btn-outline btn-small"
              style={{ width: "100%", marginTop: 8 }}
              onClick={() => setShowCurrencyModal(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      )}
      {/* Placeholder Modal */}
      {showPlaceholder && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.6)",
            zIndex: 1100,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              background: "#181C28",
              borderRadius: 18,
              padding: 32,
              minWidth: 320,
              maxWidth: 380,
              textAlign: "center",
            }}
          >
            <div style={{ fontWeight: 700, color: "#fff", marginBottom: 18 }}>
              Coming soon
            </div>
            <div style={{ color: "#94A3B8", marginBottom: 24 }}>
              {placeholderText}
            </div>
            <button
              className="btn btn-outline btn-small"
              style={{ width: "100%" }}
              onClick={() => setShowPlaceholder(false)}
            >
              Close
            </button>
          </div>
        </div>
      )}
      {/* Toast */}
      {showToast && (
        <div
          style={{
            position: "fixed",
            top: 60,
            left: 0,
            right: 0,
            display: "flex",
            justifyContent: "center",
            zIndex: 1300,
          }}
        >
          <div
            style={{
              background: "#3B82F6",
              borderRadius: 16,
              padding: "12px 24px",
              color: "#fff",
              fontWeight: 700,
              fontSize: 16,
              boxShadow: "0 2px 12px #0004",
            }}
          >
            {toastText}
          </div>
        </div>
      )}
    </div>
  );
};

export default AccountScreenLoggedIn;
